import axios from "axios";
import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  const translate = async (text, from = "auto", to = "fr") => {
    if (!text) return "";
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${from}&tl=${to}&dt=t&q=${encodeURIComponent(
      text
    )}`;

    try {
      const response = await axios.get(url);
      if (response.data && Array.isArray(response.data[0])) {
        return response.data[0].map((item) => item[0]).join(" ");
      } else {
        console.warn(
          "⚠️ Réponse inattendue de l'API Google Translate :",
          response.data
        );
        return text;
      }
    } catch (error) {
      console.error("❌ Erreur lors de la traduction :", error);
      return text;
    }
  };

  nuxtApp.provide("translate", translate);
});
